export const defaultLocale = 'en'

// key must match a shortLocale in ../locales.js for CountrySelect
export const locales = {
  // 'ar': {
  //   name: 'العربية'
  // },
  'de': {
    name: 'Deutsch'
  },
  'en': {
    name: 'English'
  },
  'es': {
    name: 'Español'
  },
  'fr': {
    name: 'Français'
  },
  'el': {
    name: 'Ελληνικά'
  },
  'it': {
    name: 'Italiano'
  },
  'pt': {
    name: 'Português'
  },
  'tr': {
    name: 'Türkçe'
  }
}
